import { APPEND_HUBACCESS } from '../actionsList';



const initialInfo = {
    list: []
};
const hubAccessReducer = (state = initialInfo, action) => {

    switch (action.type) {

        case APPEND_HUBACCESS: {
            let list = state.list

            if (!list) {
                list = []
            }
            // console.log('APPEND_HUBACCESS', action)
            action.hubAccess.map((hubAccess) => {
                let found = false
                let cIndex
                list.map((element, index) => {
                    if (hubAccess._id == element._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (!found) {
                    list.push(hubAccess)
                }
                else {
                    list[cIndex] = hubAccess
                }
            })
            // console.log('hubAccesslist is',[...list])

            return {
                ...state,
                list: list,
            }

        }
        default:
            return state;
    }
}
export default hubAccessReducer;